<template>
      <div class="publicViewClass" style="padding-top:0">
         <div class="app-inner paperFx">
             <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="$util.reback('/teacheManage/enCourse')">
            返回
            </div>
            </div>
              <div class="exam-title">
              <div class="exam-title-info flex align-cen">
                <b>课程名称：{{list.title}}</b>
              </div>
            </div>
             <div class="tabbable-custom">
              <div class="exam-analyze-ul flex align-cen">
                <div class="nav-tabs">
                     <el-tabs v-model="activeName">
                        <el-tab-pane label="学习效果" name="1">
                             <div class="rdsdiv"></div>
                              <div class="paper-content" id="paperIDPd">
                                 <div class="public-tit flex align-cen" ref="document">
                            <div class="public-tit-list">
                                <i class="icon-al-application"></i>  学习数据概况
                            </div>
                        </div>
                     <div class="quickOperate boxs">
                <div class="oprateBox flex align-cen">
                    <div class="createExam">
                        <div class="quickContainer">
                            <img src="../../../assets/images/ex4.png" alt="" class="oprateImg">
                            <div class="oprateText">总学习人数</div>
                        </div>
                        <div class="num">{{courseInfo.learnedNum || 0}}</div>
                        <el-tooltip class="item" effect="dark" content="累计至昨日，进行课程正常观看的人数总和，按照天进行更新" placement="top">
                        <span class="right-icon">
                            <i class="el-icon-warning"></i>
                        </span>
                          </el-tooltip>
                    </div>
                    <div class="createExam" >
                        <div class="quickContainer">
                            <img src="../../../assets/images/ex3.png" alt="" class="oprateImg">
                            <div class="oprateText">总完成人数</div>
                        </div>
                        <div class="num">{{courseInfo.finishNum || 0}}</div>
                            <el-tooltip class="item" effect="dark" content="累计至昨日，学完该课程的人数总和，按照天进行更新" placement="top">
                        <span class="right-icon">
                            <i class="el-icon-warning"></i>
                        </span>
                          </el-tooltip>
                    </div>
                     <div class="createExam" >
                        <div class="quickContainer" >
                            <img src="../../../assets/images/ex5.png" alt="" class="oprateImg">
                            <div class="oprateText">完课率统计</div>
                        </div>
                        <div class="num">{{courseInfo.finishRate || 0}}%</div>
                            <el-tooltip class="item" effect="dark" content="累计至昨日，学完该课程的人数/观看过该课程的人数，按照天进行更新" placement="top">
                        <span class="right-icon">
                            <i class="el-icon-warning"></i>
                        </span>
                          </el-tooltip>
                    </div>
                </div>
                      </div>
                             <!-- 折线图 -->
                                 <div class="public-tit flex align-cen" ref="document" style="margin-top:20px">
                            <div class="public-tit-list">
                                <i class="icon-al-application"></i> 学习趋势
                            </div>
              </div>
               <div class="chat-flex">
            <div class="student-detailds-chart">
                <div class="student-detailds-chart-head flex align-cen"> 
                    <span data-title="学习趋势图">学习趋势图</span>
                             <div class="businessList-filter-list flex align-cen" style="margin-left:auto">
                            <div class="label">自定义查询时间：</div>
                            <el-date-picker
                            v-model="value"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptions2"
                            @change="classSelect('')"
                            >
                            </el-date-picker>
                        </div>
                </div>
                 <div class="summaryOfTestPie">
                    <div class="exam-pr-pie">
                      <lineChart :option="LineChartOption" :barID="'lineID'"></lineChart>
                    </div>
                </div>
            </div>
                              </div>
                               <div class="chat-flex">
            <div class="student-detailds-chart">
                <div class="student-detailds-chart-head flex align-cen"> 
                    <span data-title="完课绿趋势图">完课率趋势图</span>
                             <div class="businessList-filter-list flex align-cen" style="margin-left:auto">
                            <div class="label">自定义查询时间：</div>
                            <el-date-picker
                            v-model="value1"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptions2"
                            @change="classSelect(1)"
                            >
                            </el-date-picker>
                        </div>
                </div>
                 <div class="summaryOfTestPie">
                    <div class="exam-pr-pie">
                      <lineChart :option="LineChartOption1" :barID="'lineID1'"></lineChart>
                    </div>
                </div>
            </div>
                              </div>
                               <div class="public-tit flex align-cen" ref="document" style="margin-top:20px">
                            <div class="public-tit-list">
                                <i class="icon-al-application"></i> 学习详情
                            </div>
                            <div class="public-btn mft" @click="exportExcel(itemList)">导出</div>
                              </div>
                               <div class="App-tab" style="margin-top:16px">
                                <el-table
                                :data="itemList"
                                border
                                style="width: 100%"
                                :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                                >
                                <el-table-column label="用户" align="center" prop="userName">
                      </el-table-column>
                         <el-table-column label="用户手机号" align="center" prop="loginName">
                      </el-table-column>
                      <el-table-column label="所属企业" align="center" prop="businessName">
                      </el-table-column>
                      <el-table-column label="来源" align="center" prop="">
                            <template slot-scope="scope">
                        <p>{{scope.row.orderSource == 1 ? '官网':'-'}}</p>
                        </template>
                      </el-table-column>
                      <el-table-column label="累计学习时长" align="center" prop="">
                         <template slot-scope="scope">
                        <p>{{scope.row.totalDuration || '-'}}min</p>
                        </template>
                      </el-table-column>
                      <el-table-column label="本课程学习时长" align="center" prop="">
                         <template slot-scope="scope">
                        <p>{{scope.row.duration || '-'}}min</p>
                        </template>
                      </el-table-column>
                      <el-table-column label="学习进度" align="center" prop="">
                         <template slot-scope="scope">
                        <p>{{scope.row.progress}}%</p>
                        </template>
                      </el-table-column>
                        <el-table-column label="首次学习时间" align="center" prop="firstTime">
                      </el-table-column>
                       <el-table-column label="完成时间" align="center" prop="">
                         <template slot-scope="scope">
                        <p>{{scope.row.finishTime || '-'}}</p>
                        </template>
                      </el-table-column>
                                </el-table>
                                 <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
                               </div>
                              </div>
                        </el-tab-pane>
                     </el-tabs>
                </div>
              </div>

             </div>
         </div>
      </div>
</template>
<script>
import {deletCourse,overviewCou,lineData,lineData1,tabData,saleData,lineData2} from "@/api/enterprise/index"  //获取课程详情、课程概况、学习趋势、完课趋势、学习详情、销售情况
import lineChart from "@/components/lineTemolate/index.vue"; //折线图图组件
import exportExcel from '../../../utils/exportExcel.js' //导出数据公共方法
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
import BarChart from "@/components/barTemplate/index.vue"; //柱状图图组件
export default {
    name:'courseData',
    data() {
        return {
           businessInfo:{},
            list:{},
             activeName:'1',
             courseInfo:{
              businessNum:0,
              learnedNum:0,
              finishRate:0,
              finishNum:0
             },
             courseInfo1:{
              firstCount:0,
              pvCount:0,
              payAmount:0,
              rate:0,
              payCount:0,
              uniqueCount:0
             },
             LineChartOption:{},
              LineChartOption1:{},
              BarChartOption:{},
             value:'',
              starTime:'',
            endTime:'',
            value1:'',
              starTime1:'',
            endTime1:'',
             value2:'',
              starTime2:'',
            endTime2:'',
            itemList:[],
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
              pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        }
    },
     components:{
      lineChart,
      paginaTion,
      BarChart
    },
    created() {
       this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
      this.handleTab()
      this.getPaperDetail()
    },
    methods: {
      getLineData2(){
        lineData2({id:this.$route.query.id,starTime:this.starTime2,endTime:this.endTime2})
        .then(res =>{
          let arr = res.data
              let xData = []
            let seriesData = []
            let arrData = [{
              name:'售前浏览量',
              value:'pvCount',
              color:'#FF6969'
            },{
               name:'售前访客数',
              value:'uniqueCount',
              color:'#699DFF'
            },{
               name:'支付数',
              value:'payCount',
              color:'#409eff'
            },
            {
               name:'支付金额',
              value:'payAmount',
              color:'#ee6666'
            },
            {
               name:'转化率',
              value:'rate',
              color:'#fac858'
            },
            {
               name:'首次购买用户数',
              value:'firstCount',
              color:'#ea7ccc'
            }
            ]
// 转换逻辑
           seriesData = arrData.map(({ name, value: field, color }) => ({
            name,
            value: field,
            type: 'bar',
             emphasis: {
              focus: 'series'
            },
            itemStyle:{
                    color
                  },
            data: arr.map(item =>({
              value:parseFloat(item[field]),  
              itemStyle:{color}
            }))
          }));
             for (let key in arr) {
                  xData.push(arr[key].time)
                }
                this.BarChartOption = {
                    tooltip: {
                      trigger: 'axis',
                      axisPointer: {
                        type: 'shadow'
                      }
                    },
                    legend: {},
                    grid: {
                      left: '3%',
                      right: '4%',
                      bottom: '3%',
                      containLabel: true
                    },
                    xAxis: [
                      {
                        type: 'category',
                        data: xData
                      }
                    ],
                    yAxis: [
                      {
                        type: 'value'
                      }
                    ],
                    series:seriesData
                }
        })
      },
      getSaleData(){
        saleData({id:this.$route.query.id,starTime:this.starTime2,endTime:this.endTime2})
        .then(res =>{
          if(res.data){
            this.courseInfo1 = res.data
          }else{
             this.courseInfo1 ={
              firstCount:0,
              pvCount:0,
              payAmount:0,
              rate:0,
              payCount:0,
              uniqueCount:0
             }
          }
        })
      },
                   // 子组件触发
      emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.getTabData()
      },
            //导出
          exportExcel(val){ 
             if(val.length !=0){
        let keyLisst = [] 
            for(let item in val){
             keyLisst.push( {
              '用户':val[item].userName, 
              '用户手机号':val[item].loginName, 
              '所属企业':val[item].businessName ,
              '来源': val[item].orderSource == 1 ? ' 官网' : '-',
              '累计学习时长':val[item].totalDuration,
              '本课程学习时长':val[item].duration,
              '学习进度':val[item].progress + '%',
              '首次学习时间':val[item].firstTime ,
              '完成时间':val[item].finishTime || '-' ,
              } ) 
             }
         exportExcel.exportExcel(keyLisst,this.list.title)
             }else{
                this.$message.error('未选择导出数据')
             }
        },
          // tab切换
      handleTab(){
        if(this.activeName == '1'){
            this.getGk()
            this.getLineData()
            this.getLineData1()
             this.getTabData()
        }else{
        this.getSaleData()
         this.getLineData2()
        }
      },
      getTabData(){
        tabData({id:this.$route.query.id,size:this.PageSize,current:this.currentPage,businessId:this.businessInfo.id})
          .then(res =>{
            this.itemList = res.data.records
            this.totalCount = res.data.total
          }) 
      },
      classSelect(type){
        if(this[`value${type}`]){
             this[`starTime${type}`] = this[`value${type}`][0]
            this[`endTime${type}`]  = this[`value${type}`][1]
            }else{
              this[`starTime${type}`] = ""
              this[`endTime${type}`] = ""
            }
            if(type == 2){
              this.getSaleData()
              this.getLineData2()
            }else if(type == 1 ){
              this.getLineData1()
            }else{
              this.getLineData()
            }
      },
      getLineData(){
        lineData({id:this.$route.query.id,starTime:this.starTime,endTime:this.endTime,businessId:this.businessInfo.id})
        .then(res =>{
          if(res.data){
             
               let xData1 = [],
                    sData1 = []
            for (let key in res.data) {
                xData1.push(res.data[key].time)
                sData1.push({
                name:res.data[key].time,
                num:Number(res.data[key].learnedNum),
                value:Number(res.data[key].avgDuration),
                 itemStyle: {
                    color:   '#FF6969'
                  }
              })
               }
               this.LineChartOption = {
                 tooltip: {
                    trigger: 'axis',
                    formatter:function(params){
                    var str = '';
                     str = `${params[0].name}</br>学习人数：${params[0].data.num}</br>平均学习时长(分钟)：${params[0].data.value}`
                     return str
                  }
                },
                  grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                 xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: xData1
                },
                  yAxis: {
                    type: 'value'
                },
                 series: [
                    {
                    data: sData1,
                    type: 'line',
                    emphasis: {
                        focus: 'series'
                    },
                    areaStyle: {},
                    }
                ]
               }
          }
        })
      },
       getLineData1(){
        lineData1({id:this.$route.query.id,starTime:this.starTime1,endTime:this.endTime1,businessId:this.businessInfo.id})
        .then(res =>{
            let arr = res.data
          if(arr){
               let xData1 = [],
                    sData1 = []
            for (let key in arr) {
                xData1.push(arr[key].time)
                sData1.push({
                name:arr[key].time,
                num:arr[key].finishNum,
                value:arr[key].finishRate,
                 itemStyle: {
                    color:   '#FF6969'
                  }
              })
               }
               this.LineChartOption1 = {
                 tooltip: {
                    trigger: 'axis',
                    formatter:function(params){
                    var str = '';
                     str = `${params[0].name}</br>完成学习人数：${params[0].data.num}</br>完成率：${params[0].value}`
                     return str
                  }
                },
                  grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                 xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: xData1
                },
                  yAxis: {
                    type: 'value'
                },
                 series: [
                    {
                    data: sData1,
                    type: 'line',
                    emphasis: {
                        focus: 'series'
                    },
                    areaStyle: {},
                    }
                ]
               }
          }
        })
      },
      // 获取课程概况
      getGk(){
        overviewCou({id:this.$route.query.id,businessId:this.businessInfo.id})
            .then(res =>{
              if(res.data){
                this.courseInfo = res.data
              }
            })
            .catch(err =>{})
      },
           // 获取课程详情
        getPaperDetail(){
            deletCourse({id:this.$route.query.id},'get')
            .then(res =>{
              this.list = res.data
            })
            .catch(err =>{})
        },
    },
}
</script>
<style lang="scss" scoped>
   .public-btn{
    min-width: 60px;
    cursor: pointer;
    color: #409eff;
    padding: 7px 10px;
    border-radius: 4px !important;
    text-align: center;
    border: none;
    background: #409eff;
    color: #fff;
        }
.section-title{
  margin-top: 25px;
  font-size: 16px;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #333333;
    font-weight: 700;
    text-indent: 16px;
    position: relative;
}
.section-title::before{
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 4px;
    height: 16px;
    background-color: #409eff;
    border-radius: 2px;
}
.jBox-content{
  padding: 20px 77px 24px;
  .authbtn{
    margin-top: 46px;
    justify-content: center;
  }
  .group{
        margin-bottom: 17px;
        .label{
          margin: 0 12px 0 0;
          width: 130px;
          text-align: right;
        }
        .input-group{
          width: 300px;
          height: 40px;
          .input-group-addon{
            min-width: unset;
            display: inline-block;
            width: 50px;
            height: 2px;
            margin: 0 12px;
            background-color: #999999;
            vertical-align: middle;
            border-color: #e5e5e5;
            background: #e5e5e5;
          }
        }
  }
}
.paperFx{
        .quickOperate{
        .oprateTitle{
            font-size: 20px;
            color: #333333;
            margin: 12px 0 12px 0;
        }
        .oprateBox1{
          flex-wrap: wrap;
          justify-content:normal !important;
          .createExam{
            width: 21% !important;
          }
        }
        .oprateBox{
            margin-top: 20px;
            justify-content: space-between;
            .createExam{
                position: relative;
                background-color: #ffffff;
                border-radius: 4px !important;
                border: solid 1px #eeeeee;
                width: 33%;
                padding: 10px 15px;
                margin: 0 22px 16px 0;
                cursor: pointer;
                // text-decoration: none;
                position: relative;
                .right-icon{
                    position: absolute;
                    display: block;
                    right: 10px;
                    top: 0px;
                    font-size: 20px;
                    cursor: pointer;
                }
                .num{
                   padding-left: 70px;
                    padding-top: 0px;
                    font-size: 25px;
                    font-weight: bold; 
                }
                .oprateImg, .oprateText{
                    display: inline-block;
                    vertical-align: middle;
                    margin-left: 10px;
                }
                .oprateImg{
                    max-width: 47px;
                    word-break: keep-all;
                }
                .oprateText{
                    font-size: 15px;
                    font-weight: normal;
                    color: #000000;

                }
            }
            // .createExam::before, .createExam::after{
            //         width: 100%;
            //         height: 100%;
            //         z-index: 3;
            //         content: '';
            //         position: absolute;
            //         top: 0;
            //         left: 0;
            //         box-sizing: border-box;
            //         transform: scale(0);
            //         -webkit-transition: 0.5s;
            //         transition: 0.5s;
            //         -webkit-border-radius: 4px;
            //         -moz-border-radius: 4px;
            //         border-radius: 4px;
            // }
            // .createExam:hover{
            //     border: 1px solid rgba(0, 160, 80, 0);
            // }
            .createExam1::before{
                border-bottom: 1px solid #36aafd;
                border-left: 1px solid #36aafd;
                transform-origin: 0 100%;
            }
             .createExam1::after{
                border-top: 1px solid #36aafd;
                border-right: 1px solid #36aafd;
                transform-origin: 100% 0;
            }
            .createExam2::before{
                border-bottom: 1px solid #ff962a;
                border-left: 1px solid #ff962a;
                transform-origin: 0 100%;
            }
             .createExam2::after{
                border-top: 1px solid #ff962a;
                border-right: 1px solid #ff962a;
                transform-origin: 100% 0;
            }
            .createExam3::before{
                border-bottom: 1px solid #d52b2a;
                border-left: 1px solid #d52b2a;
                transform-origin: 0 100%;
            }
             .createExam3::after{
                border-top: 1px solid #d52b2a;
                border-right: 1px solid #d52b2a;
                transform-origin: 100% 0;
            }
            .createExam:hover::after,.createExam:hover::before{
                transform: scale(1);
            }
        }
    }
  .exam-title{
    position: relative;
    padding: 0 24px;
    height: 40px;
    line-height: 40px;
    background-color: #ffffff;
    border-bottom: solid 1px #e6e6e6;
    border-radius: 10px 10px 0 0;
    font-size: 20px;
    color: #333333;
    font-weight: 600;
    cursor: default;
    b{
      font-weight: bolder;
    }
    .title-extra{
      font-size: 14px;
      font-weight: normal;
      color: #999;
    }
  }
  .tabbable-custom{
    background-color: #f3f4f8;
    position: relative;
        .student-detailds-chart{
     background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    flex: 0 0 50%;
    max-width: 100%;
    .student-detailds-chart-head{
        padding: 9px 16px;
        border-bottom: 1px solid #e6e6e6;
        span{
            font-weight: 700;
            font-size: 18px;
            color: #333;
        }
       .yks-blue{
            background-color: #36aafd;
            color: white;
            border: 1px solid #36aafd;
            padding: 7px 20px;
            border-radius: 4px!important;
            margin-left: auto;
            cursor: pointer;
       } 
    }
       .summaryOfTestPie{
          margin-top: 36px;
          .exam-pr-pie{
            height: 400px;
            padding: 20px;
            border: 1px solid #e6e6e6;
            border-radius: 10px;
          }
        }
    }
    .exam-analyze-ul{
     padding: 0 24px 20px;
    border-radius: 0 0 10px 10px!important;
    background-color: #fff;
    .nav-tabs{
    margin-top: 20px;
    margin-bottom: 0;
    border-bottom: 0;
    background-color: #fff;
    border-radius: 10px 10px 0 0!important;
    }
      .rdsdiv{
        height: 20px;
        background: #f7f8fa;
      }
    .paper-content{
        background: #fff;
        padding: 16px;
        border-radius: 5px;
        margin-bottom: 80px;
        .summaryOfTestPapers{
          .analysisTable{
            margin-top: 20px;
            .analysisTable-title{
              height: 40px;
              line-height: 40px;
              background: #eeeeee;
              span{
                width: 10.4%;
                text-align: center;
              }
              .otherSpan{
                width: 16%;
              }
            }
            .analysisTable-list{
              height: 40px;
              line-height: 40px;
              border-bottom: 1px solid #efefef;
               span{
                width: 10.4%;
                text-align: center;
              }
              .otherSpan{
                width: 16%;
              }
            }
          }
        }
        .summaryOfTestPie{
          margin-top: 36px;
          .exam-pr-pie{
            height: 400px;
            padding: 20px;
            border: 1px solid #e6e6e6;
            border-radius: 10px;
          }
        }
        .summaryOfTestPie1{
          margin: 10px 0;
          .group-score-segment{
            margin-bottom: 20px;
            .label{
              color: #333;
              font-size: 16px;
            }
            .group-score-segment-tags{
              .tag{
                position: relative;
                margin-right: 12px;
                padding: 6px 30px;
                font-size: 14px;
                color: #666;
                background-color: #f3f4f8;
                border-radius: 4px!important;
                cursor: pointer;
                .delet{
                  position: absolute;
                  top: 50%;
                  right: 10px;
                  transform: translateY(-50%);
                  width: 14px;
                  height: 14px;
                  background: url('../../../assets/images/delete.png') no-repeat center;
                  display: inline-block;
                  
                }
              }
            }
            .add-group-score-segment{
              margin-right: 10px;
              cursor: pointer;
              background-color: white!important;
            color: #333333;
            border: 1px solid #cacaca;
            padding: 7px 20px;
            border-radius: 4px!important;
            font-size: 14px;
            }
          }
        }
    }
    .right{
      .btn-set{
        min-width: 120px;
        margin-right: 16px;
        cursor: pointer;
        color: #409eff;
        border: 1px solid #409eff;
        padding: 7px 10px;
        border-radius: 4px!important;
        text-align: center;
      }
      .exportExamSa{
        border: none;
        background: #409eff;
        color: #fff;
      }
    }
    }
  }
}
::v-deep{
  .input-group{
          .ipt1{
            .el-input__inner{
              max-width: 100% !important;
              background-color: #ffffff;
              border-radius: 4px;
              border: solid 1px #e6e6e6;
            }
          }
        }
  .el-tabs__content{
    position: absolute;
    left: -16px;
    width: calc(100% + 32px);
  }
  .nav-tabs{
    .el-tabs__nav-wrap::after{
      background: none !important;
    }
    .el-tabs__item{
     width: 112px;
     text-align: center;
    font-size: 14px;
    color: #999;
    padding: 0;
    }
  .is-active{
    color: #409eff !important;
  }
  .el-tabs__active-bar{
    width: 112px !important;
  }
  }
  .el-input__inner{
    max-width: 250px;
    margin-right: 16px;
  }
       .clozeClass{
    p{
        display: inline-block !important;
      }
  }
}
</style>